import { render, staticRenderFns } from "./pbbsmry.vue?vue&type=template&id=0a8a17b7&scoped=true"
import script from "./pbbsmry.vue?vue&type=script&lang=js"
export * from "./pbbsmry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a17b7",
  null
  
)

export default component.exports